import React from 'react'
import ComponentTitle from "../Component-title/ComponentTitle"
import p1 from '../../assets/images/test/p1.png'
import p2 from '../../assets/images/test/p2.png'
import p3 from '../../assets/images/test/p3.png'
import p4 from '../../assets/images/test/p4.png'
import p5 from '../../assets/images/test/p5.jpg'

const Partners = () => {
    console.log(p1)
    return (
        <section className='partners'>
            <ComponentTitle title=' ' subTitle=' ' subTitle2='Partners'/>
            <div className="center-wrapper justify-content-center mt-5" style={{position:'relative', top:'50px'}}>
                <a href="https://magelline.com/en/ " target='_blank' rel="noreferrer">
                    <img src={p1} alt=""/>
                </a>
                <a href="https://magelline.flights/ " target='_blank' rel="noreferrer">
                    <img src={p5} alt=""/>
                </a>
                <a>
                    <img src={p2} alt=""/>
                </a>
                <a>
                    <img src={p3} alt=""/>
                </a>
                <a>
                    <img src={p4} alt=""/>
                </a>
            </div>
        </section>
    );
};

export default Partners;